import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Helper functies voor video URLs
export function getVideoType(url: string): 'youtube' | 'vimeo' | 'upload' {
  if (url.includes('youtube.com') || url.includes('youtu.be')) {
    return 'youtube'
  }
  if (url.includes('vimeo.com')) {
    return 'vimeo'
  }
  return 'upload'
}

export function getYouTubeVideoId(url: string): string | null {
  const patterns = [
    /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([^&#?]*)/,
    /youtube\.com\/watch\?.*v=([^&#]*)/
  ]
  
  for (const pattern of patterns) {
    const match = url.match(pattern)
    if (match && match[1]) {
      return match[1]
    }
  }
  return null
}

export function getVimeoVideoId(url: string): string | null {
  const pattern = /(?:vimeo\.com\/)(\d+)/
  const match = url.match(pattern)
  return match ? match[1] : null
}

export function getVideoEmbedUrl(url: string): string {
  const videoType = getVideoType(url)
  
  switch (videoType) {
    case 'youtube': {
      const videoId = getYouTubeVideoId(url)
      return videoId ? `https://www.youtube.com/embed/${videoId}` : url
    }
    case 'vimeo': {
      const videoId = getVimeoVideoId(url)
      return videoId ? `https://player.vimeo.com/video/${videoId}` : url
    }
    default:
      return url
  }
}

export function isValidVideoUrl(url: string): boolean {
  if (!url) return false
  
  // Check voor geüploade video bestanden
  if (url.match(/\.(mp4|webm|ogg|mov|avi)$/i)) {
    return true
  }
  
  // Check voor YouTube URLs
  if (getYouTubeVideoId(url)) {
    return true
  }
  
  // Check voor Vimeo URLs
  if (getVimeoVideoId(url)) {
    return true
  }
  
  return false
}
